// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_RemoveItemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for DELETE /so/orders/remove_item/{item_id}
 *
 * Returns the id of the removed item as a primitive int (legacy wire shape).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_RemoveItemResponseDados = number;

export type Orders_RemoveItemResponse = ApiResponse<Orders_RemoveItemResponseDados>;

registerResponseContract('Orders_RemoveItemResponse', {})
